/** App session hooks — room/desk fetch removed with asset renting. */

/** No-op — rooms API / desk board removed. */
export const useFetchRooms = () => {};

/** No-op stubs — Settings/Navigation no longer mutate desk rooms. */
export const useLocalRoomUpdate = () => ({
  addLocalRoom: (_room?: unknown) => {},
  addLocalRooms: (_rooms?: unknown) => {},
  getEditedRooms: (_a?: unknown, _b?: unknown) => [] as unknown[],
  editLocalRoom: (_rooms?: unknown) => {},
  deleteLocalRooms: (_ids?: string[]) => {},
});

export const useRooms = () => ({ rooms: null as Array<{ id: string, roomTypeId?: string }> | null });

/** Legacy desk booking helpers — always empty after asset-renting removal. */
export const useRoomsData = () => ({
  getCurrentBooking: (_roomId?: string): any => undefined,
  getAllBooks: (_roomId?: string): any[] => [],
});
